import { createRequest } from './base';

export const request = createRequest({
  baseURL: process.env.REACT_APP_API_BASE_URL!,
  headers: {
    'X-TZOFFSET': (-1 * new Date().getTimezoneOffset()) / 60,
  },
});
